import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
const DEFAULT_SKELETON_AS = "div";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Skeleton = ({ as, height, width = "100%", radius = 4, style, className, children, // in case for some reason, someone wants something inside the skeleton
...rest }) => {
    const Tag = as || DEFAULT_SKELETON_AS;
    const innerStyles = {
        borderRadius: `var(--eds-radii-${radius})`,
        height,
        width,
    };
    return (_jsx(Tag, { style: { ...innerStyles, ...style }, className: classNames("eds-skeleton", className), tabIndex: 0, "aria-label": "Loading", ...rest, children: children }));
};
